import { Cube } from '../../cube/core/cube';
import * as CubeTree from '../../cubeTree/index';
import Utils from '../../utils/util';
import FrontCubeData from '../../frontCubeData/index';
import DragSyStem from '../../dragSyStem/index';
import Drag from '../drag/index';
import Update from '../../update/index';
import CodiSystem from '../../codiSystem/index';

async function runNormalInsert(insertTasks: InsertInfo[]): Promise<CubeId[]> {
    let addCubes: CubeId[] = [];

    for (let i = 0; i < insertTasks.length; i++) {
        let beAddedCube: CubeNode = await runInsertTask(insertTasks[i]);

        addCubes.push(beAddedCube.id);
    }

    return addCubes;
}

function runInsertTask(insertTask: InsertInfo): Promise<CubeNode> {
    return new Promise<CubeNode>((resolve: (cube: CubeNode) => void, reject: () => void): void => {
        let copyTask: InsertInfo = Utils.deepCopy(insertTask);
        let parentCube: CubeNode = CubeTree.findByCubeId(copyTask.parentId);
        let cubeInstance: CubeNode = new Cube(copyTask.insertData, parentCube, {
            created: (cube: CubeNode): void => {
                CubeTree.add(cube.id, cube);
                FrontCubeData.add(cube);
            }
        });

        // 挂载
        parentCube.add(cubeInstance, copyTask.index, (beAddedCube: CubeNode) => {
            CodiSystem.deepScan(beAddedCube.id);
            DragSyStem.addDeep(beAddedCube.id);
            Drag.add(beAddedCube.id);
            resolve(beAddedCube);
        });
    });
}

export {
    runNormalInsert
};
